import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { put, takeLatest } from "redux-saga/effects";
import { getUserByToken } from "./authCrud";

export const actionTypes = {
  Login: "[Login] Action",
  Logout: "[Logout] Action",
  Register: "[Register] Action",
  UserRequested: "[Request User] Action",
  UserLoaded: "[Load User] Auth API",
  UserProfileLoaded: "[Load User Profile] Auth API",
  ModulesLoaded: "[Load Modules] Auth API",
  MenuesLoaded: "[Load Menues] Auth API",
  SetUser: "[Set User] Action",
  SetMenuType: "[Set Menu Type] Action",
  CoreModuleLogin: "[CoreModuleLogin] Action",
  SetFEPermission: "[CoreModuleLogin] SetFEPermission",
  CompanySettingsLoaded: "[CompanySettingsLoaded] Action",
};

const initialAuthState = {
  user: undefined,
  userProfile: undefined,
  authToken: undefined,
  coreModuleInfo: undefined,
  modules: undefined,
  menuType: undefined,
  menu: [],
  menuObj: {},
  flatMenu: [],
  fe_permissions: [],
  companySettings: null,
};

export const reducer = persistReducer(
  {
    storage,
    key: "unitoken",
    whitelist: [
      "authToken",
      "menu",
      "coreModuleInfo",
      "userProfile",
      "fe_permissions",
      "companySettings",
      "user",
      "menuObj",
    ],
  },
  (state = initialAuthState, action) => {
    switch (action.type) {
      case actionTypes.Login: {
        const { authToken } = action.payload;
        return { authToken, user: undefined };
      }

      case actionTypes.CoreModuleLogin: {
        const { coreModuleInfo } = action.payload;
        return { ...state, coreModuleInfo };
      }

      case actionTypes.Register: {
        const { authToken } = action.payload;

        return { authToken, user: undefined };
      }

      case actionTypes.Logout: {
        // TODO: Change this code. Actions in reducer aren't allowed.

        return initialAuthState;
      }

      case actionTypes.UserLoaded: {
        const { user } = action.payload;
        return { ...state, user };
      }

      case actionTypes.UserProfileLoaded: {
        const { userProfile } = action.payload;
        return { ...state, userProfile };
      }

      case actionTypes.ModulesLoaded: {
        const { modules } = action.payload;
        return { ...state, modules };
      }

      case actionTypes.SetUser: {
        const { user } = action.payload;
        return { ...state, user };
      }

      case actionTypes.MenuesLoaded: {
        const { menu, menuObj, flatMenu } = action.payload;
        return { ...state, menu, menuObj, flatMenu };
      }

      case actionTypes.CompanySettingsLoaded: {
        const { companySettings } = action.payload;
        return { ...state, companySettings };
      }

      case actionTypes.SetMenuType: {
        const { menuType } = action.payload;
        return { ...state, menuType };
      }

      case actionTypes.SetFEPermission: {
        return { ...state, fe_permissions: action.payload };
      }

      default:
        return state;
    }
  }
);

export const actions = {
  login: (authToken) => ({ type: actionTypes.Login, payload: { authToken } }),
  coreModuleLogin: (coreModuleInfo) => ({
    type: actionTypes.CoreModuleLogin,
    payload: { coreModuleInfo },
  }),
  register: (authToken) => ({
    type: actionTypes.Register,
    payload: { authToken },
  }),
  logout: () => ({ type: actionTypes.Logout }),
  requestUser: (user) => ({
    type: actionTypes.UserRequested,
    payload: { user },
  }),
  fulfillUser: (user) => ({ type: actionTypes.UserLoaded, payload: { user } }),
  fulfillUserProfile: (userProfile) => ({
    type: actionTypes.UserProfileLoaded,
    payload: { userProfile },
  }),
  modules: (modules) => ({
    type: actionTypes.ModulesLoaded,
    payload: { modules },
  }),
  menu: (menu, menuObj, flatMenu) => ({
    type: actionTypes.MenuesLoaded,
    payload: { menu, menuObj, flatMenu },
  }),
  companySettings: (companySettings) => ({
    type: actionTypes.CompanySettingsLoaded,
    payload: { companySettings },
  }),
  setUser: (user) => ({ type: actionTypes.SetUser, payload: { user } }),
  menuType: (menuType) => ({
    type: actionTypes.SetMenuType,
    payload: { menuType },
  }),
  setFEPermission: (permission) => ({
    type: actionTypes.SetFEPermission,
    payload: permission,
  }),
};

export function* saga() {
  yield takeLatest(actionTypes.Login, function* loginSaga() {
    yield put(actions.requestUser());
  });

  // yield takeLatest(actionTypes.CoreModuleLogin, function* loginSaga() {
  //   yield put(actions.requestUser());
  // });

  yield takeLatest(actionTypes.Register, function* loginSaga() {
    yield put(actions.requestUser());
  });
}
